/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./js/styleguide.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Styleguide: () => (/* binding */ Styleguide)
/* harmony export */ });
class Styleguide extends HTMLElement {
  constructor() {
    super();

    this.ctn = this.querySelector(".styleguide-menu");
    this.btnMenu = this.querySelector(".styleguide-commands-menu");
    this.btnFW = this.querySelector(".styleguide-commands-fw");
    this.menus = this.querySelectorAll(".styleguide-style-section");
    this.container = this.querySelector(".styleguide-container");
    this.styles = this.querySelector('.styleguide-styles');
    this.content = "";
  }

  connectedCallback() {
    this.generateMenu();

    this.btnMenu.addEventListener("click", () => this.toggleMenu());
    this.btnFW.addEventListener("click", () => this.toggleFW());
  }

  generateMenu() {
    this.menus.forEach(el => {
      const title = el.querySelector(".styleguide-style-section-title");
      const submenus = el.querySelectorAll("[data-submenu]");

      this.content += `
        <ul>
          <li>
            <a href="#${title.id}">${title.innerHTML}</a>
            <ul>
              ${[...submenus]
                .map(
                  submenu =>
                    `<li><a href="#${submenu.id}">${submenu.innerHTML}</a></li>`
                )
                .join("")}
            </ul>
          </li>
        </ul>
      `;
    });

    this.ctn.innerHTML = this.content;
  }

  toggleMenu() {
    this.ctn.parentElement.classList.toggle("hide-xxs");
    
  }

  toggleFW() {
    this.classList.toggle("full-width");
    this.container.classList.toggle("ctn");
    this.container.classList.toggle("ctn-fluid");
    this.styles.classList.toggle('xxs12')
  }
}

customElements.define("styleguide-ctn", Styleguide);

/******/ })()
;
//# sourceMappingURL=styleguide.js.map